import React, {Component} from "react";

export default class EditBoardField extends Component{
    state = {
        hovered: false,
    }

    onMouseEnter(){
        this.setState({hovered:true})
    }
    onMouseLeave(){
        this.setState({hovered:false})
    }
    handleInputChange(event) {
        this.setState({fieldInput: event.target.value});
    }
    componentDidMount() {
        this.oldText = this.props.fieldValue;
        this.setState({fieldInput: this.props.fieldValue, field: this.props.field});
    }
    oldText = "";
    onFocus(event){
        this.oldText = event.target.value;
    }
    deleteField(){
        let board = this.props.board;
        delete board.fields[this.props.field];
        this.props.updateBoard(board)
        //     ,function (){
        //     this.setState({deleted:true})
        // }.bind(this), function (err){
        //     this.setState({deletedError:err})
        // }.bind(this));
    }
    updateField(){
        if(this.state.fieldInput !== this.oldText){
            let board = this.props.board;
            board.fields[this.props.field] = this.state.fieldInput;
            this.props.updateBoard(board);
            //     function (){
            //     this.setState({updated:true})
            //     setTimeout(function (){
            //         this.setState({updated:false})
            //     }.bind(this),3000);
            // }.bind(this), function (err){
            //     // this.setState({updated:true})
            //     this.setState({updateError:err})
            // }.bind(this))
        }
    }
    updateFieldKey(){
        if(this.state.field !== this.props.field){
            let board = this.props.board;
            // board.fields[this.state.field] = board.fields[this.props.field];
            // delete board.fields[this.props.field];
            let fields = {};
            for(let key in board.fields){
                if(key === this.props.field){
                    fields[this.state.field.toLowerCase()] = board.fields[key];
                }else{
                    fields[key] = board.fields[key];
                }
            }
            board.fields = fields;
            this.props.updateBoard(board);
            //     function (){
            //     this.setState({updated:true})
            //     setTimeout(function (){
            //         this.setState({updated:false})
            //     }.bind(this),3000);
            // }.bind(this), function (err){
            //     // this.setState({updated:true})
            //     this.setState({updateError:err})
            // }.bind(this))
        }
    }
    render(){
        return <tr onMouseEnter={()=>this.onMouseEnter()}
                    onMouseLeave={()=>this.onMouseLeave()}>
            {/*{(()=>{*/}
            {/*    if(this.state.deleted){*/}
            {/*        return <td colSpan={2} className={"green-txt"}>Deleted!</td>*/}
            {/*    }else if(this.state.deletedError){*/}
            {/*        return <td colSpan={2} className={"red-txt"}>Unable to Delete: {this.state.deletedError.toString()}</td>*/}
            {/*    }else{*/}
            {/*        return <>*/}
                        <th className={"p-0"}>
                            <input
                                onBlur={()=>this.updateFieldKey()}
                                onChange={(ev)=>this.setState({field: ev.target.value})}
                                type="text"
                                value={this.state.field}/>
                            {this.state.hovered ? <span onClick={()=>this.deleteField()} className={"close-icon"}/> : <></>}
                        </th>
                        <td>
                            <input
                                onBlur={()=>this.updateField()}
                                onChange={(ev)=>this.handleInputChange(ev)}
                                type="text"
                                value={this.state.fieldInput}/>
                            {/*{this.state.updated ? <span className={"green-txt"}>Updated!</span>: <></>}*/}
                            {/*{this.state.updateError ? <p className={"red-txt"}>Update error: {this.state.updateError.toString()}</p>: <></>}*/}
                        </td>
                    {/*</>*/}
            {/*     }*/}
            {/* })()}*/}
        </tr>
    }
}
